/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Success_Create_TitleInputs */

const es_feedback_modal_success_create_title = /** @type {(inputs: Feedback_Modal_Success_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback enviado`)
};

const en_feedback_modal_success_create_title = /** @type {(inputs: Feedback_Modal_Success_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback sent`)
};

/**
* | output |
* | --- |
* | "Feedback sent" |
*
* @param {Feedback_Modal_Success_Create_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_success_create_title = /** @type {((inputs?: Feedback_Modal_Success_Create_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Success_Create_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_success_create_title(inputs)
	return en_feedback_modal_success_create_title(inputs)
});
export { feedback_modal_success_create_title as "feedback.modal.success_create_title" }